import {
  StyleSheet,
  ImageBackground,
  useWindowDimensions,
  SafeAreaView,
  Platform,
} from "react-native";
import React from "react";

import { View, ScrollView, Heading, Text, Pressable } from "native-base";
import Card from "../../components/Card";
import { StackScreenProps } from "../../types";
import BottomSlidingImages from "../../components/BottomSlidingImages";
import Header from "../../components/Header";

const Distribution = ({ navigation }: StackScreenProps<"ResearchAndDev">) => {
  const { height, width } = useWindowDimensions();

  const partners = [
    { image: require("../../assets/partners/binl.png"), name: "BINL" },
    { image: require("../../assets/partners/circum-farms.png"), name: "" },
    { image: require("../../assets/partners/novus-agro.png"), name: "" },
    { image: require("../../assets/partners/raregeode.png"), name: "" },
    { image: require("../../assets/partners/thrive.png"), name: "" },
    { image: require("../../assets/partners/upl.png"), name: "" },
    { image: require("../../assets/partners/value-seeds.png"), name: "" },
    { image: require("../../assets/partners/barnksforte.png"), name: "" },
    { image: require("../../assets/partners/mas.png"), name: "" },
  ];

  const data = [
    {
      heading: "Farm And Fortune Hub (FFH)",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("FFH"),
      image: require("../../assets/vectors/house.png"),
    },
    {
      heading: "OCP Agripromoters",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("Agriprometers"),
      image: require("../../assets/vectors/search.png"),
    },
  ];

  return (
    <ImageBackground
      source={require("../../assets/background.png")}
      resizeMode="repeat"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView
            contentContainerStyle={{
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            <View>
              <Header
                onPress={() => navigation.navigate("Home")}
                headingText="Last-Mile Distribution"
                intro="This project will not just secure significant goodwill from Nigeria government but will utilize gas from Nigeria and Phosphate from Morocco to make Nigeria self-sufficient in fertilizer production. This industrial plant will serve as source of Nitrogen to Morocco & Phosphate to Nigeria and share resources between both countries to make Nigeria the preferred source of phosphate-based fertilizer to west Africa neighbors.  "
                parentText=""
              />

              <View px={5}>
                {data.map((item) => (
                  <Pressable key={item.heading} mb={10} onPress={item.onPress}>
                    <Card
                      heading={item.heading}
                      subheading={item.subheading}
                      details={item.details}
                      iconName={item.iconName}
                      onPress={item.onPress}
                      borderBottomColor="#333"
                      borderColor="#aaa"
                      bg="#00943A"
                      image={item?.image}
                    />
                  </Pressable>
                ))}
              </View>
            </View>

            <BottomSlidingImages partners={partners} />
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default Distribution;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 156, 78, 0.7)",
  },
});
